import InfoIcon from '@mui/icons-material/InfoRounded';
import { styled } from '@mui/material/styles';

const PREFIX = 'ProcessInfo';

const classes = {
  infoIcon: `${PREFIX}-infoIcon`,
  infoIconDiv: `${PREFIX}-infoIconDiv`
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.infoIcon}`]: {
    position: 'absolute',
    bottom: '4px',
    right: '4px',
    color: theme.palette.primary.main,
    zIndex: 1,
    '&:hover': { color: theme.palette.info.light, cursor: 'pointer' }
  },
  [`& .${classes.infoIconDiv}`]: {
    visibility: 'hidden'
  }
}));

interface ProcessInfoIconProps {
  onClick: () => void;
}

const ProcessInfoIcon = ({ onClick }: ProcessInfoIconProps) => {
  return (
    <Root>
      <div className={classes.infoIconDiv}>
        <InfoIcon
          fontSize="large"
          onClick={onClick}
          className={classes.infoIcon}
          data-testid="process-info-icon"
        />
      </div>
    </Root>
  );
};

export default ProcessInfoIcon;
